module.exports = __webpack_public_path__ + "static/media/it-landscape.d7795a94.jpg";